import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import * as Sentry from '@sentry/react'
import { registerSW } from 'virtual:pwa-register'
import './index.css'
import App from './App'

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  integrations: [
    Sentry.replayIntegration({
      maskAllText: false,
      maskAllInputs: false,
    }),
  ],

  replaysOnErrorSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  beforeSend(event, hint) {
    const error = hint.originalException;
    if (error && typeof error === 'object' && 'response' in error) {
      const status = (error as any).response?.status;
      if (status === 401 || status === 403 || status === 404) {
        return null; // Descarta estos eventos
      }
    }
    if (error && error instanceof Error) {
      if (error.message === 'Network Error' || error.message.includes('Network request failed')) {
        return null; // Descarta errores de red conocidos
      }
    }
    return event;
  },
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)

// Register the PWA service worker with auto-update.
// When a new build is deployed, the SW will skip waiting and
// activate immediately — the user always gets the latest version.
registerSW({
  onRegisteredSW(_, registration) {
    if (registration) {
      // Poll for updates every 60 seconds so even a long-lived
      // tab picks up deployments quickly.
      setInterval(() => {
        if (registration.active?.state === 'redundant') return;
        registration.update().catch(() => {
          // capturamos el error silenciosamente
        })
      }, 60 * 1000)
    }
  },
  onOfflineReady() { },
})

